import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Habit } from 'src/app/habit.model';

export class HabitValidators {

  static habitExistValidator(
    habitsToCheck$: Observable<{ [key: string]: Habit }>
  ): AsyncValidatorFn {
    return (control: AbstractControl) =>
      of(control.value).pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((habit) =>
          habitsToCheck$.pipe(
            switchMap((habits) =>
              !!habits[habit] ? of({ habitExist: true }) : of(null)
            )
          )
        )
      );
  }
}
